export default __webpack_public_path__ + "static/media/Integration.5752e095.png";